import { Box, Typography } from '@mui/material';
import * as React from 'react';

export function Header() {
  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        paddingLeft: theme => theme.spacing(2),
        '&>*': {
          marginLeft: theme => theme.spacing(2)
        },
        backgroundColor: '#B4C1CC',
        height: 60
      }}
    >
      <img
        width="120"
        src={require('../resources/logo.png')}
        alt="HackforPlay"
      />
      <Typography variant="h6">みまもり設定</Typography>
    </Box>
  );
}
